import { Box } from "@mui/material";
import React from "react";
import type { FieldConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { DimensionField, MetaDescriptorBase, MetaField } from "../../../../../../../../api/types/svTypes.ts";
import { ItemDataType } from "../../../../../../../../api/types/svTypes.ts";
import DisplayFieldsComponent from "../../common/fields/format/DisplayFieldsComponent";
import TextField from "../../common/fields/format/TextField";

const getTextFields = <T extends MetaField<MetaDescriptorBase>>(fields: T[]): T[] => {
  return fields.filter((v) => v.meta.type === ItemDataType.General);
};

interface Props {
  fields: DimensionField[];
  onUpdateConfig: (field: DimensionField, changes: Partial<FieldConfiguration>) => void;
  readonlyMode: boolean;
}

export default function TextFieldContainer({ fields, onUpdateConfig, readonlyMode }: Props) {
  const textFields = React.useMemo(() => getTextFields(fields), [fields]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
      {textFields.map((field) => (
        <TextField key={field.meta.name} field={field}>
          <DisplayFieldsComponent field={field} onUpdateConfig={onUpdateConfig} readonlyMode={readonlyMode} />
        </TextField>
      ))}
    </Box>
  );
}
